export const session = {
  setCookie: (name, value, days) => {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
    console.log(`Set cookie: ${name}=${value}; expires=${expires}; path=/`); // Debugging
  },
  getCookie: (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) {
        const value = c.substring(nameEQ.length, c.length);
        console.log(`Retrieved cookie: ${name}=${value}`); // Debugging
        return value;
      }
    }
    return null;
  },
  eraseCookie: (name) => {
    document.cookie = name + "=; path=/; Max-Age=-99999999;";
    console.log(`Erased cookie: ${name}`); // Debugging
  },
};
